function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Payment page Footer
 * 
 */
import * as React from 'react';
import ErrorMessage from '../../../components/error-message/ErrorMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { gateway } from '../../../actions/index';
import CreditCardForm from '../credit-card-form/CreditCardForm';
import IPSIframe from '../iframe/IPSIframe';
import { API, COSTS, OPTIONS, IS_PROD, gatewayForDomain } from '../../../data/Data';
import moment from 'moment';
import './Footer.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Footer extends React.Component {
  constructor(props) {
    super(props);
    // $FlowFixMe
    _defineProperty(this, "formRef", void 0);
    /**
     * Process
     */
    _defineProperty(this, "process", e => {
      e.preventDefault();
      this.submitForm();
    });
    /**
     * submit
     */
    _defineProperty(this, "submit", () => {
      const {
        application
      } = this.props;
      const {
        gateway
      } = this.state;
      const {
        name,
        redirectUrl
      } = this.state.gateway;
      const {
        params
      } = this.ipsiParams(gateway);
      const {
        id,
        submission_token
      } = application;
      const data = name === 'ipsi' ? {
        submission_token,
        redirect_url: redirectUrl,
        params
      } : {
        submission_token,
        redirect_url: redirectUrl
      };
      const options = {
        ...OPTIONS,
        method: 'POST',
        body: JSON.stringify(data)
      };
      const url = `${API}/${id}/payment/${name}/token`;
      this.setState({
        apiError: false,
        spinner: true
      });
      fetch(url, options).then(response => {
        if (response.status >= 400) {
          const message = `HTTP status code: ${response.status}`;
          const err = new Error(message);
          response.json().then(result => console.warn('Payment Page Footer failed API call', result));
          throw err;
        } else {
          return response.json();
        }
      }).then(result => this.success(result)).catch(err => this.error(err));
    });
    /**
     * IPSI params
     */
    _defineProperty(this, "ipsiParams", gateway => {
      const {
        application,
        jest,
        postage
      } = this.props;
      const {
        id
      } = application;
      const amount = (COSTS.permit + postage.cost).toFixed(2);
      const name = IS_PROD ? 'idp.iframe' : 'RAA.Travel.IDP.iframe.demo';
      const configId = IS_PROD ? '3b0450ba-44a9-426a-aa46-b4b1a75ce71d' : '0409559a-f412-4350-a3a7-049e93689c1d';
      const search = new URLSearchParams();
      const timestamp = jest ? '1623294796806' : moment().format('X');
      search.set('amount', amount);
      search.set('currency', 'AUD');
      search.set('txnType', '0');
      search.set('userName', name);
      search.set('configId', configId);
      search.set('merchReference', `${id}-${timestamp ? timestamp : ''}`);
      gateway = {
        ...gateway,
        params: search.toString(),
        timestamp
      };
      return gateway;
    });
    /**
     * success posting to API
     */
    _defineProperty(this, "success", result => {
      const {
        setGateway
      } = this.props;
      const {
        id
      } = this.props.application;
      const {
        community_code,
        gateway_url,
        reply_url,
        success,
        merchant_id,
        paymentReference,
        timestamp,
        token
      } = result ? result : {
        community_code: '',
        gateway_url: '',
        merchant_id: null,
        paymentReference: '',
        reply_url: '',
        timestamp: null,
        success: false,
        token: ''
      };
      const haveVars = this.haveGatewayVars(result);

      // handle API validation errors
      if (!success || !haveVars) {
        const error = new Error();
        console.warn('Error posting to API', result);
        this.error(error, `Payment gateway error for application #${id}`);
        return false;
      }
      setGateway({
        community_code,
        gateway_url,
        reply_url,
        merchant_id,
        paymentReference,
        timestamp,
        token
      });
      this.setState({
        apiError: false,
        process: true
      }, () => this.submitForm());
    });
    /**
     * Error
     */
    _defineProperty(this, "error", (err, message = '') => {
      const {
        bugsnagClient,
        jest
      } = this.props;
      if (jest) return null;
      console.warn(err);
      bugsnagClient.notify(err);
      this.setState({
        apiError: true,
        apiErrorMessage: message ? message : err.message
      });
    });
    /**
     * Redirect by submitting the hidden form
     * Works for westpac and NAB Transact
     */
    _defineProperty(this, "submitForm", () => {
      const {
        abbreviation
      } = this.props.application.club;
      const haveVars = this.haveGatewayVars(null);
      switch (true) {
        case !this.formRef || !this.formRef.current || !haveVars:
          return null;
        case abbreviation === 'AANT':
        case abbreviation === 'RACV':
          setTimeout(() => {
            this.formRef.current.submit();
          }, 2000); // delay added for UX
          break;
        default:
        // no op
      }
    });
    /**
     * Do we have the correct gateway vars to redirect?
     */
    _defineProperty(this, "haveGatewayVars", result => {
      const abbr = this.props.application.club.abbreviation;
      let {
        community_code,
        gateway_url,
        merchant_id,
        timestamp,
        token
      } = result ? result : this.props.transaction;
      switch (true) {
        case abbr === 'AANT' && community_code !== null && gateway_url !== null && token !== null:
        case abbr === 'RAA' && gateway_url !== null && token !== null:
        case abbr === 'RAC' && gateway_url !== null && token !== null:
        case abbr === 'RACQ' && gateway_url !== null && token !== null:
        case abbr === 'RACV' && gateway_url !== null && token !== null && merchant_id !== null:
        case abbr === 'RACT' && gateway_url !== null && token !== null:
        case abbr === 'NRMA' && gateway_url !== null && token !== null && timestamp !== null && merchant_id !== null:
          return true;
        default:
          return false;
      }
    });
    const {
      application: _application,
      jest: _jest,
      postage: _postage
    } = props;
    const {
      id: _id,
      submission_token: _submission_token
    } = _application;
    const {
      host
    } = window.location;
    const _amount = _postage.cost + COSTS.permit;
    let _gateway = !_jest ? gatewayForDomain(host, _id, _submission_token, _amount.toFixed(2), _postage.description) : {
      name: '',
      method: '',
      redirectUrl: ''
    };
    if (_gateway.name === 'ipsi') {
      _gateway = this.ipsiParams(_gateway);
    }
    this.state = {
      apiError: false,
      apiErrorMessage: '',
      gateway: _gateway,
      process: false,
      spinner: true
    };
    this.formRef = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    // get token from API for redirect to payment
    this.submit();
  }
  componentWillUnmount() {
    clearTimeout();
  }
  renderRedirectUI() {
    const {
      community_code,
      gateway_url,
      token
    } = this.props.transaction;
    const {
      apiError,
      spinner,
      process
    } = this.state;
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsxs("form", {
        ref: this.formRef,
        action: gateway_url,
        children: [/*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "communityCode",
          value: community_code ? community_code : ''
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "token",
          value: token ? token : ''
        })]
      }), /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: "triangle-exclamation",
          className: "left"
        }), /*#__PURE__*/_jsxs("strong", {
          children: ["Please don't use the browser's back button. Press", ' ', /*#__PURE__*/_jsx(Link, {
            className: "cancel",
            to: "/summary",
            children: "Cancel Payment"
          }), ' ', "if you would like to go back to the previous screen."]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "footer actions",
        children: [/*#__PURE__*/_jsxs(Link, {
          className: "button cancel reverse",
          to: "/summary",
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: "xmark"
          }), "Cancel Payment"]
        }), /*#__PURE__*/_jsxs("div", {
          className: `button process${gateway_url ? '' : ' disabled'}`,
          onClick: this.process,
          role: "button",
          tabIndex: "0",
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: apiError ? 'triangle-exclamation' : spinner ? 'spinner' : 'check'
          }), !process ? /*#__PURE__*/_jsx("span", {
            children: "Process Order"
          }) : /*#__PURE__*/_jsx("span", {
            children: "Redirecting"
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "patience",
        children: /*#__PURE__*/_jsxs("p", {
          children: ["Please wait while you are redirected to the payment server. If nothing happens within 15 seconds, please click on the", ' ', /*#__PURE__*/_jsx("span", {
            className: `link process${gateway_url ? '' : ' disabled'}`,
            onClick: this.process,
            role: "button",
            tabIndex: "0",
            children: "Process Order"
          }), ' ', "button above."]
        })
      })]
    });
  }
  renderRedirectToNabTransact() {
    const {
      postage,
      transaction
    } = this.props;
    const {
      gateway_url,
      merchant_id,
      paymentReference,
      reply_url,
      token
    } = transaction;
    let {
      redirectUrl
    } = this.state.gateway;
    const {
      apiError,
      spinner,
      process
    } = this.state;
    redirectUrl = redirectUrl + '&bank_reference=&payment_reference=&payment_amount=&payment_number=&payment_date=&fingerprint=' + '&postageDescription=' + encodeURIComponent(postage.description || 'Express Post within Australia');
    const replyUrl = reply_url + '&bank_reference=&payment_reference=&payment_amount=&payment_number=&payment_date=&fingerprint=';
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsxs("form", {
        ref: this.formRef,
        action: gateway_url,
        children: [/*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "fingerprint",
          value: token ? token : ''
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "vendor_name",
          value: merchant_id ? merchant_id : ''
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "payment_reference",
          value: paymentReference ? paymentReference : ''
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "return_link_url",
          value: redirectUrl ? redirectUrl : ''
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "reply_link_url",
          value: replyUrl ? replyUrl : ''
        }), /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "International Driving Permit",
          value: COSTS.permit.toFixed(2)
        }), postage.cost > 0 && /*#__PURE__*/_jsx("input", {
          type: "hidden",
          name: "Postage",
          value: postage.cost.toFixed(2)
        })]
      }), /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: "triangle-exclamation",
          className: "left"
        }), /*#__PURE__*/_jsxs("strong", {
          children: ["Please don't use the browser's back button. Press", ' ', /*#__PURE__*/_jsx(Link, {
            className: "cancel",
            to: "/summary",
            children: "Cancel Payment"
          }), ' ', "if you would like to go back to the previous screen."]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "footer actions",
        children: [/*#__PURE__*/_jsxs(Link, {
          className: "button cancel reverse",
          to: "/summary",
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: "xmark"
          }), "Cancel Payment"]
        }), /*#__PURE__*/_jsxs("div", {
          className: `button process${gateway_url ? '' : ' disabled'}`,
          onClick: this.process,
          role: "button",
          tabIndex: "0",
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: apiError ? 'triangle-exclamation' : spinner ? 'spinner' : 'check'
          }), !process ? /*#__PURE__*/_jsx("span", {
            children: "Process Order"
          }) : /*#__PURE__*/_jsx("span", {
            children: "Redirecting"
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "patience",
        children: /*#__PURE__*/_jsxs("p", {
          children: ["Please wait while you are redirected to the payment server. If nothing happens within 15 seconds, please click on the", ' ', /*#__PURE__*/_jsx("span", {
            className: `link process${gateway_url ? '' : ' disabled'}`,
            onClick: this.process,
            role: "button",
            tabIndex: "0",
            children: "Process Order"
          }), ' ', "button above."]
        })
      })]
    });
  }

  /**
   * Render iFrame for FatZebra Direct Post
   */
  renderFatZebraIframe() {
    const {
      token,
      gateway_url
    } = this.props.transaction;
    if (!token || !gateway_url) return null;
    const {
      redirectUrl
    } = this.state.gateway;
    const params = new URLSearchParams();
    params.set('iframe', 'true');
    params.set('show_extras', 'false');
    params.set('show_email', 'false');
    params.set('masterpass', 'false');
    params.set('visacheckout', 'false');
    params.set('tokenize_only', 'true');
    params.set('return_path', redirectUrl);
    const src = `${gateway_url}?${params.toString()}`;
    return /*#__PURE__*/_jsx("iframe", {
      src: src,
      title: "Payment iFrame"
    });
  }
  render() {
    const {
      application,
      bugsnagClient,
      postage,
      transaction
    } = this.props;
    const {
      apiError,
      apiErrorMessage,
      gateway
    } = this.state;
    const {
      name,
      method
    } = gateway;
    let content = null;
    switch (true) {
      case name === 'fatzebra':
        content = this.renderFatZebraIframe();
        break;
      case name === 'ipsi':
        content =
        /*#__PURE__*/
        // $FlowFixMe
        _jsx(IPSIframe, {
          application: application,
          bugsnagClient: bugsnagClient,
          gateway: gateway,
          postage: postage,
          transaction: transaction
        });
        break;
      case name === 'nab-transact':
        content = this.renderRedirectToNabTransact();
        break;
      case method === 'form':
        content = /*#__PURE__*/_jsx(CreditCardForm, {
          bugsnagClient: bugsnagClient,
          formRef: this.formRef,
          gateway: gateway
        });
        break;
      default:
        content = this.renderRedirectUI();
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "Footer",
      children: [content, /*#__PURE__*/_jsx(ErrorMessage, {
        error: apiError,
        message: apiErrorMessage
      })]
    });
  }
}
_defineProperty(Footer, "defaultProps", {
  application: {
    club: {
      abbreviation: 'RACV'
    },
    id: '1500',
    referrer: '',
    submission_token: 'f23re5et'
  },
  postage: {
    description: 'Express Post within Australia',
    cost: 11.75,
    value: 'express_post'
  },
  transaction: {
    community_code: null,
    gateway_url: null,
    merchant_id: null,
    paymentAmount: null,
    paymentDate: null,
    paymentReference: null,
    receiptNumber: null,
    reply_url: null,
    responseCode: null,
    responseDescription: null,
    summaryCode: null,
    success: false,
    token: null,
    tokenSuccess: null
  },
  jest: false
});
const mapStateToProps = ({
  application,
  postage,
  transaction
}) => {
  return {
    application,
    postage,
    transaction
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setGateway: value => {
      dispatch(gateway(value));
    }
  };
};
const VisibleFooter = connect(mapStateToProps, mapDispatchToProps)(Footer);
export default VisibleFooter;